import script from "./MessagesWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessagesWidget.vue?vue&type=script&lang=ts&setup=true"

import "./MessagesWidget.vue?vue&type=style&index=0&id=c1621188&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1621188"]])

export default __exports__